import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { OrdersMainPanels } from '../components/orders/OrdersMainPanels';
import { WideLayout } from '../../../shared/layout/widelayout';

export const OrdersPage: React.FC = () => {
    return <WideLayout outlet={<OrdersMainPanels />} forceWebView={true} />;
};
